import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { motion } from "motion/react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

export const PasswordInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => {
  const [show, setShow] = React.useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={show ? "text" : "password"} className="pr-11" {...props} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-lg p-2 text-muted-foreground transition hover:bg-muted hover:text-foreground"
        aria-label={show ? "Jelszó elrejtése" : "Jelszó megjelenítése"}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

const LEVELS = [
  { label: "Nagyon gyenge", color: "bg-destructive" },
  { label: "Gyenge", color: "bg-destructive" },
  { label: "Elmegy", color: "bg-warning" },
  { label: "Erős 💪", color: "bg-success" },
  { label: "Páncélszekrény 🔐", color: "bg-success" },
];

export function PasswordStrength({ value }: { value: string }) {
  let score = 0;
  if (value.length >= 10) score++;
  if (value.length >= 14) score++;
  if (/\d/.test(value) && /[a-zA-Z]/.test(value)) score++;
  if (/[^a-zA-Z0-9]/.test(value) || (/[a-z]/.test(value) && /[A-Z]/.test(value))) score++;
  if (!value) return null;
  const lvl = LEVELS[score];
  return (
    <div className="space-y-1.5 pt-1">
      <div className="flex gap-1.5">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-1.5 flex-1 overflow-hidden rounded-full bg-muted">
            <motion.div className={cn("h-full rounded-full", lvl.color)} initial={false} animate={{ width: i < score ? "100%" : "0%" }} transition={{ duration: 0.3, delay: i * 0.05 }} />
          </div>
        ))}
      </div>
      <div className="text-xs font-medium text-muted-foreground">{lvl.label}</div>
    </div>
  );
}
